<template>
  <section class="content_auto">
    <div class="c2-container">
      <div class="photo-box">
        <div class="title">
          {{ $t('证件正反面照片') }}
        </div>
        <div class="upload-box">
          <CustomUpload
            v-model="frontPhoto"
            :title="$t('上传证件正面')"
            className="front-photo"
          >
          </CustomUpload>
          <CustomUpload
            v-model="backPhoto"
            :title="$t('上传证件反面')"
            className="back-photo"
          ></CustomUpload>
        </div>
      </div>
      <div class="photo-box">
        <div class="title">
          {{ $t('手持证件照片') }}
          <span>
            {{ $t('如右图示') }}
          </span>
        </div>
        <div class="upload-box">
          <CustomUpload
            v-model="handPhoto"
            className="hand-photo"
          ></CustomUpload>
          <div class="example-img-box">
            <img :src="require('@/assets/images/example.png')" />
          </div>
        </div>
      </div>

      <div class="tips-box">
        <div class="title">{{ $t('上传要求') }}</div>
        <div class="tip-item">1 {{ $t('必须能看清证件信息') }}</div>
        <div class="tip-item">
          2
          {{
            $t(
              '提交本申请代表承诺你的身份信息真实可靠，不存在盗用他人信息的情况'
            )
          }}
        </div>
        <div class="tip-item">
          3
          {{
            $t('上传材料需用JPG/JPEG/PNG格式,大小不超过xM，信息清晰', {
              size: 8
            })
          }}
        </div>
      </div>
      <div class="commit-btn-box">
        <el-button
          :loading="loading"
          :disabled="disabled"
          class="commit-btn"
          @click="commit"
        >
          {{ $t('提交') }}
        </el-button>
      </div>
    </div>
  </section>
</template>
<script>
import { doCommitC2Auth } from '@/api/personal'
import { updateUserInfo } from '@/utils'

export default {
  name: 'KYC2Auth',
  data() {
    return {
      frontPhoto: '',
      handPhoto: '',
      backPhoto: '',
      loading: false
    }
  },
  computed: {
    disabled() {
      return !this.frontPhoto || !this.handPhoto || !this.backPhoto
    }
  },
  methods: {
    async commit() {
      this.loading = true
      try {
        const { frontPhoto, handPhoto, backPhoto } = this
        await doCommitC2Auth({ frontPhoto, handPhoto, backPhoto })
        this.$Message.success(this.$t('操作成功'))
        await updateUserInfo()
        this.$router.replace({ path: '/identity' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
section {
  .c2-container {
    width: 724px;
    margin: 0 auto;
    .photo-box {
      .title {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        margin-bottom: 16px;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #a2a2a2;
          line-height: 24px;
          margin-left: 8px;
        }
      }
      .upload-box {
        display: flex;
        justify-content: space-between;

        .example-img-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 348px;
          img {
            width: 271px;
            height: 175px;
          }
        }
      }

      &:nth-child(1) {
        margin-bottom: 32px;
      }
      &:nth-child(2) {
        margin-bottom: 16px;
      }
    }
    .tips-box {
      .title {
        height: 24px;
        font-size: 16px;
        font-weight: 500;
        color: #c02e21;
        line-height: 24px;
        margin-bottom: 14px;
      }
      .tip-item {
        font-size: 16px;
        font-weight: 500;
        color: #848e9c;
        line-height: 24px;
        &:not(:first-child) {
          margin-top: 8px;
        }
      }
    }
    .commit-btn-box {
      margin: 64px 0 100px;
      text-align: center;
      .commit-btn {
        width: 580px;
        height: 60px;
        text-align: center;
        border-radius: 4px 4px 4px 4px;
        font-size: 18px;
        font-weight: 500;
        background: #1c1b1b;
        color: #ffffff;
        cursor: pointer;
        &.el-button.is-disabled,
        &.el-button.is-disabled:focus,
        &.el-button.is-disabled:hover {
          background: #a2a2a2;
          color: #fff;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
